<template>
  <div class="guard-select">
      <h3 v-if="!isWeiXin">猎头寻求工作/挂靠</h3>
      <div class="item">
          <img src="./hc.png" alt="" />
          <span @click="go('rhc')">我要挂靠</span>
      </div>
      <div class="item" style="margin-top:100px;">
          <img src="./hh.png" alt="" />
          <span @click="go('rhh')">我要找工作</span>
      </div>
  </div>
</template>
<style lang="scss" scoped>
  .guard-select {
      padding-top:40px;
      h3 {
          text-align: center;
          
          font-size: 20px;
      }
      .item {
          margin-top: 50px;
          text-align: center;
          img {
              display: block;
              width:28%;
              margin:0 auto;
          }
          span {
              cursor: pointer;
              display:inline-block;
              width:115px;
              height:35px;
              line-height:35px;
              margin-top:35px;
              background: #E74C3C;
              border-radius: 25px;
              text-align: center;
              color:#fff;
          }
      }
  }
</style>
<script>
export default {
  name: "guard-select-module",
  data(){
    return {
        isWeiXin:false
    }
  },
  watch: {
  },
  components: {},
  methods: {
      go(link){
          let o = {};
          
          this.$router.push(link)
      }
  },
  created() {
      
    let isWeiXin = () => {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    };
    if (isWeiXin()) {
      this.isWeiXin = true;
      this.$store.commit('comp/WX_SHARE',{
            title:'守卫猎头计划开启',
            desc:'猎上网推出五大扶持猎头政策',
            link:window.location.origin + '/hh-wx/activity/guardhunter'
        });
    } else {
      this.isWeiXin = false;
    }
  }
};
</script>
